import {
	RadioButtonUnchecked,
	CheckCircleOutlined,
	RadioButtonChecked,
} from '@mui/icons-material';
import {
	Stepper,
	Step,
	StepConnector,
	stepConnectorClasses,
	styled,
	Stack,
	InputLabel,
	Tooltip,
} from '@mui/material';

import styles from './Stepper.module.scss';

const { backgroundColor, borderColor, radioColor, checkedradioColor } = styles;

interface Props {
	steps: string[];
	activeIndex: number;
}

const StepperComponent = (props: Props) => {
	const { steps, activeIndex } = props;

	const StepperComponentConnector = styled(StepConnector)(({ theme }) => ({
		paddingRight: '4px',
		[`&.${stepConnectorClasses.active}`]: {
			[`& .${stepConnectorClasses.line}`]: {
				borderColor: backgroundColor,
			},
		},
		[`&.${stepConnectorClasses.completed}`]: {
			[`& .${stepConnectorClasses.line}`]: {
				borderColor,
			},
		},
		[`& .${stepConnectorClasses.line}`]: {
			borderColor:
				theme.palette.mode === 'dark' ? theme.palette.grey[800] : radioColor,
			borderTopWidth: 4,
			borderRadius: 2,
		},
	}));

	return (
		<Stepper connector={<StepperComponentConnector />}>
			{steps.map((label: string, index: number) => {
				const completedOrInactive =
					index === activeIndex ? (
						<RadioButtonChecked sx={{ color: checkedradioColor }} />
					) : (
						<RadioButtonUnchecked sx={{ color: radioColor }} />
					);

				return (
					<Stack
						className={styles['steps-stack-container']}
						key={`${label}-step`}
					>
						<Step
							completed={index < activeIndex}
							active={index === activeIndex}
							key={label}
							className={styles['stepper-step']}
							data-testid="stepper-step"
						>
							{}
						</Step>
						<Stack
							direction="row"
							className={styles['alternative-label-stack']}
							alignItems="center"
							justifyContent="center"
						>
							{index < activeIndex ? (
								<CheckCircleOutlined
									fontSize="small"
									sx={{ color: checkedradioColor }}
								/>
							) : (
								completedOrInactive
							)}
							<Tooltip title={label}>
								<InputLabel
									disabled={index > activeIndex}
									className={styles['stepper-label']}
									data-testid="input-label"
								>
									{label}
								</InputLabel>
							</Tooltip>
						</Stack>
					</Stack>
				);
			})}
		</Stepper>
	);
};

export default StepperComponent;
